module.exports = __webpack_public_path__ + "static/Wide-6fc1a1c3f74843b7cdac8d14977ff56b.woff";